import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PrimaryHeader from '../../../../../../common/PrimaryHeader';
import SecondaryHeader from '../../../../../../common/SecondaryHeader';
import SecondaryNavigation from '../../../../../../common/SecondaryNavigation';
import CustomReportsDropdown from '../../../../customReports/components/CustomReportsDropdown';
import { ReportingAiBot } from '../../../../../../../modules/shared/reports/reporting-ai-bot';

class Header extends Component {
  static propTypes = {
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node,
    ]).isRequired,
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    pathname: PropTypes.string.isRequired,
    compact: PropTypes.bool.isRequired,
  };

  isItemActive(item) {
    const regex = RegExp(`${item.to}$`);
    return regex.test(this.props.pathname);
  }

  render() {
    return (
      <div className="s-v2">
        <PrimaryHeader>
          <div className="u-flex u-flex-1 u-align-items-center">
            <div className="c-header-primary__title extralarge-and-down-ml0" data-automation-id="text:header">
              {this.props.title}
            </div>
            <CustomReportsDropdown className="u-hidden-for-medium-and-down" compact={this.props.compact} />
            <SecondaryNavigation className="u-hidden-for-medium-and-down">
              {this.props.items.map((item) => {
                if (item.displayIf && !item.displayIf(this.props)) return null;
                return (
                  <SecondaryNavigation.Item
                    key={item.to}
                    label={item.label}
                    to={item.to}
                    primary={item.primary && !this.props.compact}
                    primaryRight={item.primaryRight}
                    active={this.isItemActive(item)}
                  />
                );
              })}
            </SecondaryNavigation>
            <ReportingAiBot />
          </div>
        </PrimaryHeader>
        <SecondaryHeader className="u-visible-for-small">
          <SecondaryNavigation mobile>
            {
              this.props.items.map((item) => {
                if (item.displayIf && !item.displayIf(this.props)) return null;

                return (
                  <SecondaryNavigation.Item key={item.to} label={item.label} to={item.to} />
                );
              })
            }
            <CustomReportsDropdown mobile />
          </SecondaryNavigation>
        </SecondaryHeader>
      </div>
    );
  }
}

export default Header;
